<template lang="pug">
.bq-warning.bq-warning--danger(v-if="!user?.email_verified")
    span.material-symbols-outlined.bq-banner-icon(translate="no") warning
    span Please verify your email address.
    | 
    a.bq-link(@click="proceedVerification = true") [Verify now]

Modal(:open="proceedVerification" @close="!sendingEmail && (proceedVerification = false)")
    .bq-modal-wrap
        .bq-modal-close(@click="!sendingEmail && (proceedVerification = false)" :class="{disabled: sendingEmail}") &times;
        .bq-modal-step
            h2 Email Verification
            p.bq-modal-desc Send a verification code to #[b(translate="no") {{ user.email }}]?
            button.btn(
                type="button"
                @click="sendEmail"
                :class="{ 'bq-btn--loading': sendingEmail }"
            )
                span.bq-loader(v-if="sendingEmail")
                template(v-else) Send Code
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { skapi } from "@/main";
import { SkapiError } from "skapi-js";
import { user } from "@/code/user";
import Modal from "@/components/modal.vue";
import { verificationTemplateOption } from "@/code/auto_email";

const router = useRouter();

let proceedVerification = ref(false);
let sendingEmail = ref(false);

let sendEmail = async () => {
    sendingEmail.value = true;
    try {
        await skapi.verifyEmail(undefined, verificationTemplateOption() as any);
        proceedVerification.value = false;
        router.push("/email-verification");
    } catch (err) {
        if (!(err instanceof SkapiError)) throw err;
        throw err;
    } finally {
        sendingEmail.value = false;
    }
};
</script>

<style lang="less" scoped>
@import "@/assets/less/bq-tokens.less";

.bq-warning {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    border: 1px solid @warning-border;
    background: @warning-bg;
    color: @warning;
    font-family: @mono;
    font-size: 0.82rem;
    margin-bottom: 0.5rem;
    line-height: 1.5;

    &--danger {
        border-color: @danger;
        background: @danger-bg;
        color: @danger;
    }
}

.bq-banner-icon {
    font-size: 1.2rem;
}

.bq-link {
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
}

.bq-modal-wrap {
    position: relative;
    padding: 2.5rem;
    font-family: @mono;
    color: @ink;
    width: 28rem;
    max-width: 100%;
}

.bq-modal-close {
    position: absolute;
    top: 1.25rem;
    right: 1.5rem;
    font-size: 1.5rem;
    line-height: 1;
    cursor: pointer;
    color: @muted;
    transition: color 0.15s;

    &:hover {
        color: @ink;
    }
}

.bq-modal-step {
    h2 {
        margin: 0 0 0.5rem;
        font-size: 1.3rem;
        font-weight: 600;
    }
}

.bq-modal-desc {
    margin: 0 0 1.5rem;
    font-size: 0.88rem;
    color: @muted;
    line-height: 1.6;
}

.btn {
    width: 100%;
}
</style>
